import { useEffect } from "react";
import { Icon } from "@iconify/react/dist/iconify.js";
import "./css/layout.css";
import { useNavigate } from "react-router-dom";

const QuizLayout = ({ children }) => {
  const navigate = useNavigate();

  const exitQuiz = async () => {
    try {
      if (document.fullscreenElement) {
        await document.exitFullscreen();
      }
    } catch (err) {
      console.log("Error saliendo de fullscreen:", err);
    }

    navigate("/");
  };

  // Cerrar con ESC en desktop
  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === "Escape") {
        exitQuiz();
      }
    };

    window.addEventListener("keydown", handleKeyDown);
    return () => window.removeEventListener("keydown", handleKeyDown);
  }, []);

  // Iconos flotantes para el fondo
  const floatingIcons = [
    { icon: "mdi:lightbulb", delay: 0, x: "10%", y: "15%" },
    { icon: "mdi:brain", delay: 0.5, x: "85%", y: "20%" },
    { icon: "mdi:star-four-points", delay: 1, x: "15%", y: "75%" },
    { icon: "mdi:palette", delay: 1.5, x: "80%", y: "70%" },
    { icon: "mdi:heart", delay: 2, x: "50%", y: "10%" },
    { icon: "mdi:flash", delay: 2.5, x: "25%", y: "45%" },
    { icon: "mdi:music-note", delay: 0.8, x: "70%", y: "45%" },
    { icon: "mdi:atom", delay: 1.3, x: "40%", y: "80%" },
    { icon: "mdi:puzzle", delay: 1.8, x: "90%", y: "50%" },
    { icon: "mdi:rocket", delay: 0.3, x: "5%", y: "55%" },
    { icon: "mdi:compass", delay: 2.2, x: "60%", y: "85%" },
    { icon: "mdi:target", delay: 1.1, x: "35%", y: "25%" },
  ];

  return (
    <div className="quiz-layout">
      {/* Fondo animado con iconos flotantes */}
      <div className="floating-icons-bg">
        {floatingIcons.map((item, idx) => (
          <div
            key={idx}
            className="floating-icon"
            style={{
              left: item.x,
              top: item.y,
              animationDelay: `${item.delay}s`,
            }}
          >
            <Icon icon={item.icon} />
          </div>
        ))}
      </div>

      {/* Botón atrás — visible en desktop */}
      <button className="quiz-back-btn" onClick={exitQuiz}>
        <Icon icon="mdi:arrow-left" width="18" />
        <span>Atrás</span>
      </button>

      {/* Botón X — visible en móvil/tablet */}
      <button
        className="quiz-close-btn"
        onClick={exitQuiz}
        aria-label="Cerrar quiz"
      >
        <Icon icon="mdi:close" width="22" />
      </button>

      <div className="quiz-stage">
        

        {children}
      </div>
    </div>
  );
};

export default QuizLayout;
